import Swiper, { EffectFade, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/effect-fade";

class SliderText {
  constructor(el) {
    this.DOM = el;
    this.create(this.DOM.querySelector(".mySwiper"));
  }

  create(slider) {
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 30,
      effect: "fade",
      modules: [Navigation, EffectFade],
      speed: 750,
      navigation: {
        prevEl: ".section-slider .swiper-button-prev",
        nextEl: ".section-slider .swiper-button-next",
      },
    });
  }

  static bind() {
    const sliders = document.querySelectorAll(".section-slider");
    sliders.forEach((el) => new SliderText(el));
  }
}
SliderText.bind();
